import { faCloudExclamation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ErrorMessage } from '@partful/features/instructions/ui/ErrorMessage';
import { useListVersionLanguages } from '@partful/features/instructions/version-languages/lib/useListVersionLanguages';
import { VersionModel } from '@partful/instructions-domain-models';
import { LoadingSpinner } from '@partful/shared/ui/LoadingSpinner/LoadingSpinner';
import { useTranslation } from 'react-i18next';
import { DefaultLanguageForm } from './DefaultLanguageForm/DefaultLanguageForm';
import styles from './InstructionsTab.module.scss';
import { SegmentsEditor } from './SegmentsEditor/SegmentEditor';

type InstructionsTabProps = {
  version: VersionModel;
};

export function InstructionTab({ version }: Readonly<InstructionsTabProps>) {
  const { data: versionLanguages, isLoading, isError } = useListVersionLanguages(version.instructionId, version.id);

  const { t: i18n } = useTranslation();

  if (isLoading) {
    return <LoadingSpinner className={styles.loader} />;
  }

  if (isError) {
    return (
      <div className={styles.error}>
        <ErrorMessage
          icon={<FontAwesomeIcon icon={faCloudExclamation} />}
          message={i18n('instructions:manage.version.instructions.loadFailed.message')}
          title={i18n('instructions:manage.version.instructions.loadFailed.title')}
        />
      </div>
    );
  }

  if (versionLanguages && versionLanguages?.length > 0) {
    return <SegmentsEditor version={version} versionLanguages={versionLanguages} />;
  }

  return <DefaultLanguageForm version={version} />;
}
